import { HttpUtil } from './http.init'
//import { UsersService } from '../services/users.service'

export class MasterService {

    static async getMasterList(entity){
        const response = await HttpUtil.request('get',`api/${entity}`,true,{});
        return response.data;
    }

    static async saveMasterList(entity,id,data){
        var _method = (id == "" ? "post" : "put");
        var _path = (id == "" ? `api/${entity}` : `api/${entity}/update-${id}`);
        const response = await HttpUtil.request(_method,_path,true,data);
        return response;
    }

    static async deleteMaster(entity,id)
    {
        const response = await HttpUtil.request("delete",`api/${entity}/delete-${id}`,true);
        return response;
    }

    static async getZoneByPrivilege(id){
        const response = await HttpUtil.request('get',`api/privilege_mapping/privilege-${id}`,true,{});
        return response.data;
    }
    static async saveZoneByPrivilege(id,zone,isSelect){
        var _method = isSelect ? "post" : "delete";
        const response = await HttpUtil.request(_method,`api/privilege_mapping/privilege-${id}-zone-${zone}`,true,{});
        return response;
    }

    static async saveData(method,entity,data){
        const response = await HttpUtil.request(method,`api/${entity}`,true,data);
        return response;
    }
}